import {styled} from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import * as React from "react";
import {useContext} from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import AppIcon from "@mui/icons-material/Apps";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import {rgba} from "polished";
import {ViewContext} from "../../state/view";


const drawerWidth = 160;

const StyledListItemText = styled(ListItemText)({
    color: rgba(255, 255, 255, 0.7),
});

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

export const MainListItems = (changeView) => {
    const {view} = useContext(ViewContext);

    return (
        <React.Fragment>
            <ListItemButton selected={view === 'App'} onClick={() => changeView('App')}>
                <ListItemIcon>
                    <AppIcon/>
                </ListItemIcon>
                <StyledListItemText primary="Apps"/>
            </ListItemButton>
            <ListItemButton selected={view === 'orders'} onClick={() => changeView('orders')}>
                <ListItemIcon>
                    <ShoppingCartIcon/>
                </ListItemIcon>
                <StyledListItemText primary="Orders"/>
            </ListItemButton>
        </React.Fragment>
    )
};

export const secondaryListItems = () => (
    <React.Fragment>
        <ListItemButton onClick={() => {
            window.localStorage.removeItem('sofi_client_token'); // remove token
            window.location.href = '/auth';
        }}>
            <ListItemIcon>
                <LogoutIcon/>
            </ListItemIcon>
            <ListItemText primary="Logout"/>
        </ListItemButton>
    </React.Fragment>
);
